import React from 'react';
import { intervalToDuration, formatDuration } from 'date-fns';

import OneValue from 'components/OneValue';
import roundToGivenDecimals from 'common/roundToGivenDecimals';
import getHashrateValueWithUnit from 'common/getHashrateValueWithUnit';

const ScoringHashrate = ({ total, lastShare }: { total: string, lastShare: string }) => {
  if(!total) {
    return null;
  }

  const parsedTotal = parseFloat(total);
  const { unit, coefficient } = getHashrateValueWithUnit(parsedTotal);
  const computedTotal = roundToGivenDecimals(parsedTotal / coefficient, 2);

  // A worker that has never submitted a share has no (or an epoch-zero) last
  // share. new Date(null/'')/new Date(0) both fall back to the Unix epoch, so
  // computing a duration would render a nonsensical "56 years ago". Treat any
  // missing, invalid, or epoch-zero timestamp as "never".
  const lastShareDate = lastShare ? new Date(lastShare) : null;
  const hasLastShare = lastShareDate !== null
    && !Number.isNaN(lastShareDate.getTime())
    && lastShareDate.getTime() > 0;

  const computedLastShare = hasLastShare
    ? `${formatDuration(
      intervalToDuration({
        end: new Date(),
        start: lastShareDate as Date,
      })
      , { delimiter: ', ' })} ago`
    : 'never';

  return (
    <OneValue
      title='Scoring Hashrate'
      value={computedTotal}
      unit={`${unit}h/s`}
      info={`Last share ${computedLastShare}`}
    />
  );
};

export default ScoringHashrate;
